export class SignatureModel {
    Id: number;
    UserId: number;
    DocumentId: number;
    SignatureData: string;
    SignatureDataBinary: any; // Using `any` for binary data; can be adjusted as needed
    CreatedAt: string;
    UpdatedAt: string;

    constructor(
        Id: number,
        UserId: number,
        DocumentId: number,
        SignatureData: string,
        SignatureDataBinary: any,
        CreatedAt: string,
        UpdatedAt: string
    ) {
        this.Id = Id;
        this.UserId = UserId;
        this.DocumentId = DocumentId;
        this.SignatureData = SignatureData;
        this.SignatureDataBinary = SignatureDataBinary;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}
